<template>
  <AppLayout :show-app-preview="false">
    <div class="content">
      <img alt="Hellocare" src="../assets/images/logo.png">
      <h1>Cette page n'existe pas</h1>
    </div>
  </AppLayout>
</template>

<script>
  import AppLayout from '../components/AppLayout';

  export default {
    name: 'NotFoundPage',
    components: { AppLayout },
  };
</script>

<style lang="scss" scoped>
  img {
    display: block;
    width: 100px;
    margin: 0 auto 3rem;
  }
</style>
